import React from 'react';
import styles from './style.less';

export default (props) => (
  <div className={styles.loading}>加载中...</div>
);